import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseApiService } from 'src/app/shared/services/base-api.service';
import { environment } from 'src/environments/environment';
import { GeneralResponse, PaginatedList } from 'src/app/shared/shared-data-models';

@Injectable({
  providedIn: 'root'
})
export class NotificationDataService {
  private readonly controllerUrl =
    `${environment.appConfig.adminGatewayServiceBaseUrl}/api/1/Notifications/`;

  constructor(private readonly baseApi: BaseApiService<any>) {}

  GetNotificationsList(pageIndex: number, pageSize: number): Observable<GeneralResponse<PaginatedList<any>>> {
    return this.baseApi.Get(
      `${this.controllerUrl}GetNotificationsList?pageIndex=${pageIndex}&pageSize=${pageSize}`
    );
  }

  GetNotificationDetails(notificationId: string): Observable<GeneralResponse<any>> {
    return this.baseApi.Get(
      `${this.controllerUrl}GetNotificationDetails?notificationId=${notificationId}`
    );
  }

  GetUnreadNotificationsCount(): Observable<GeneralResponse<any>> {
    return this.baseApi.Get(`${this.controllerUrl}GetUnreadNotificationsCount`);
  }

  ReadNotification(notificationId: string): Observable<GeneralResponse<any>> {
    return this.baseApi.Put(
      `${this.controllerUrl}ReadNotification?notificationId=${notificationId}`,
      {}
    );
  }

  ReadAll(): Observable<GeneralResponse<any>> {
    return this.baseApi.Put(`${this.controllerUrl}ReadAll`, {});
  }
}
